var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenSourceSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12111_27062)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 4.08398V12.2507",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12111_27062)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.75521 10.5C1.6005 10.5 1.45213 10.4385 1.34273 10.3291C1.23333 10.2197 1.17188 10.0714 1.17188 9.91667V2.33333C1.17188 2.17862 1.23333 2.03025 1.34273 1.92085C1.45213 1.81146 1.6005 1.75 1.75521 1.75H4.67188C5.29071 1.75 5.88421 1.99583 6.32179 2.43342C6.75938 2.871 7.00521 3.46449 7.00521 4.08333C7.00521 3.46449 7.25104 2.871 7.68863 2.43342C8.12621 1.99583 8.7197 1.75 9.33854 1.75H12.2552C12.4099 1.75 12.5583 1.81146 12.6677 1.92085C12.7771 2.03025 12.8385 2.17862 12.8385 2.33333V9.91667C12.8385 10.0714 12.7771 10.2197 12.6677 10.3291C12.5583 10.4385 12.4099 10.5 12.2552 10.5H8.75521C8.29108 10.5 7.84596 10.6844 7.51777 11.0126C7.18958 11.3408 7.00521 11.7859 7.00521 12.25C7.00521 11.7859 6.82083 11.3408 6.49265 11.0126C6.16446 10.6844 5.71934 10.5 5.25521 10.5H1.75521Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12111_27062",
  x: 6.5,
  y: 3.58398,
  width: 2,
  height: 10.167,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27062"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12111_27062",
  x: 0.671875,
  y: 1.25,
  width: 13.6641,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27062"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenSourceSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";